import { useEffect, useState } from "react";
import { actions } from "../../store";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { inventoryAPIs } from "../../apis";
import { InventoryState } from "../../store/reducers/inventoryReducer";
import { NavBar } from "../../components/NavBar/NavBar";
import { FilterGridType, InventoryFilter } from "../../utils/enums";
import { CustomRangeSlider } from "../../components/CustomRangeSlider/CustomRangeSlider";
import { Searchbox } from "../../components/Searchbox/Searchbox";
import { InventoryDataGrid } from "./InventoryData";
import { CommandBar, Container, MainSection } from "../../components";


export const Inventory = () => {
    const state = useAppSelector((state: any): InventoryState => state.inventory);
    const { inventory } = actions;
    const dispatch = useAppDispatch();
    const {common} = actions;

    const inventoryFilters = [
        InventoryFilter.PART_NAME
    ]

    const getFilterValue = (name: InventoryFilter): any[] => {
        const index = state.filterValues.findIndex((filter: any) => filter.name === name);
        if (index > -1) {
            return state.filterValues[index].value;
        } else {
            return [];
        }
    }

    useEffect(() => {
        inventoryAPIs.getInventoryData({
            pageNumber: state.pagination.pageNumber,
            limit: state.pagination.limit,
            searchText: state.searchText,
            partName: getFilterValue(InventoryFilter.PART_NAME).map(item => item.value),
            qlStart: getFilterValue(InventoryFilter.LEFT)[0],
            qlEnd: getFilterValue(InventoryFilter.LEFT)[1],
            qpStart: getFilterValue(InventoryFilter.PURCHASED)[0],
            qpEnd: getFilterValue(InventoryFilter.PURCHASED)[1],
            quStart: getFilterValue(InventoryFilter.USED)[0],
            quEnd: getFilterValue(InventoryFilter.USED)[1],
            qwStart: getFilterValue(InventoryFilter.WASTED)[0],
            qwEnd: getFilterValue(InventoryFilter.WASTED)[1],
        }).then((inventoryData: any) => {
            dispatch(inventory.setInventory(inventoryData.results));
            dispatch(inventory.setPagination({
                pageNumber: inventoryData.pageNumber,
                limit: inventoryData.limit,
                totalPages: inventoryData.totalPages,
                totalResults: inventoryData.totalResults,
                currentResults: inventoryData.currentResults
            }))
        }).catch((error: any) => {
            console.log(error);
            common.setFlyMsg({isError: true, msg:"Error in fetching components data"});
        })
    }, [state.searchText, state.pagination, JSON.stringify(state.filterValues)])

    const setPagination = (pageNumber: number) => {
        dispatch(inventory.setPageNumber(pageNumber));
    }

    const handleSearch = (e: any) => {
        dispatch(inventory.setSearchText(e.target.value));
    }

    const handleRangeFilter = (data: any) => {
        switch (data.name) {
            case "Quantity Used":
                dispatch(inventory.setFilters({ name: InventoryFilter.USED, value: data.values }))
                break;
            case "Quantity Left":
                dispatch(inventory.setFilters({ name: InventoryFilter.LEFT, value: data.values }))
                break;
            case "Quantity Purchased":
                dispatch(inventory.setFilters({ name: InventoryFilter.PURCHASED, value: data.values }))
                break;
            case "Quantity Wasted":
                dispatch(inventory.setFilters({ name: InventoryFilter.WASTED, value: data.values }))
                break;
        }
    }

    const getFilters = () => {
        return [<Searchbox
            displayLabel
            key="searchbox"
            onChange={handleSearch}
        />,
        <CustomRangeSlider
            label="Quantity Left"
            name="Quantity Left"
            minValue={0}
            maxValue={1000}
            setValuesFn={handleRangeFilter}
            key="quantity-left-slider"
            id="quantity-left-slider"
        />,
        <CustomRangeSlider
            label="Quantity Purchased"
            name="Quantity Purchased"
            minValue={0}
            maxValue={1000}
            setValuesFn={handleRangeFilter}
            key="quantity-purchased-slider"
            id="quantity-purchased-slider"
        />,
        <CustomRangeSlider
            label="Quantity Used"
            name="Quantity Used"
            minValue={0}
            maxValue={1000}
            setValuesFn={handleRangeFilter}
            key="quantity-used-slider"
            id="quantity-used-slider"
        />,
        <CustomRangeSlider
            label="Quantity Wasted"
            name="Quantity Wasted"
            minValue={0}
            maxValue={1000}
            setValuesFn={handleRangeFilter}
            key="quantity-wasted-slider"
            id="quantity-wasted-slider"
        />]
    }

    return <Container>
        <NavBar
            sectionName="Inventory"
            name="inventory"
        />
        <MainSection>
            <CommandBar
                searchFn={handleSearch}
                setDropdownFn={inventory.setFilters}
                gridType={FilterGridType.INVENTORY}
                dropdowns={inventoryFilters}
                dropdownValues={state.filterValues}
                actions={[]}
            >
            </CommandBar>
            <InventoryDataGrid></InventoryDataGrid>
        </MainSection>
    </Container>
}